import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import letsDoItIcon from "../../../assets/images/lets-do-it-icon.svg";
import starIcon from "../../../assets/images/communicate-star-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import {
  CALENDAR_RESERVATION_TYPE,
  MEMBER_BENEFITS_TYPE,
  MENU_ITEM,
} from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { getMemberBenefitsRealLifeImages } from "utils/utils";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";
import { IMAGE_LINK } from "utils/strings";

const EventDetailScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedTabBar } = useTabBar();

  useEffect(() => {
    trackDetailView("events", "EVENTS");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (
      fromPath === ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL ||
      fromPath === ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL
    ) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.EVENTS,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>Experiences</span>
        </div>
        <div
          className="calendar-detail-banner-image-container"
          style={{ backgroundImage: `url(${IMAGE_LINK.EXPERIENCES})` }}
        ></div>
        <div className="calendar_detail-container">
          <span>
            About <span style={{ color: "#ff6b35" }}>Experiences</span>
          </span>
          <div className="divider"></div>
          <div className="communicate_space_container ">
            <span className="sub_text">
              SabeHub hosts curated experiences for founders, business owners,
              who want more than casual networking. Designed to help you meet
              the right people, protect your energy, and build with more
              clarity.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> The Foundry Brunch Club
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> The Foundry Sports Night
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> The Foundry Dinner Meet
            </span>
            <span className="sub_text">Many more Curated Experiences.</span>
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={getMemberBenefitsRealLifeImages(
              MEMBER_BENEFITS_TYPE.EVENTS,
            )}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <div
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          See Upcoming Experiences
          <img src={letsDoItIcon} alt="lets-do-it-logo" />
        </div>
      </div>
    </div>
  );
};

export default EventDetailScreen;
